import React from "react";
import Header from "../../Header";
import { Button, Container, Grid, Typography } from "@mui/material";
import SeoImg from "../../../../assets/image/Seo-optimization.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import AppUiDesign from "../../../../assets/image/app-ui-design.png";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import "./MobileAppDev.css";
import Footer from "../../Footer";

const SeoServices = () => {
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "Website Design and Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Web Portal Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Custom Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Ecommerce Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Support & Maintenance",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "ERP Solutions",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];
  return (
    <>
      <Header />
      <section style={{ paddingTop: "30px" }}>
        <Container>
          <Grid container spacing={6}>
            <Grid item xs={12} md={6}>


              <img src={SeoImg} alt="Zoodonix e-com" />
            </Grid>
            <Grid item xs={12} md={6}>

              <p
                className="text-bold text-uppercase"
                style={{ color: "#5747e4" }}
              >
                Our Vision
              </p>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "bold",

                }}
              >
                We Provide
                Best SEO Services
              </Typography>
              <p className="ts-18">
                Expert SEO services to get your website ranked across top search engines.
              </p>
              <p className="ts-18"><span>Grow leads for your business by using recommended </span><span>SEO strategies that will help your audience discover</span><br data-optly-15222d10-7190-49d9-9711-bed46e5258fd="" /><span>your website more easily.</span></p>
              <div>
                <ul>
                  <li style={{ padding: '0 0 8px' }}>Dedicated SEO Manager</li>
                  <li style={{ padding: '0 0 8px' }}>Keyword Targeting</li>
                  <li style={{ padding: '0 0 8px' }}>Content Relevancy</li>
                  <li style={{ padding: '0 0 8px' }}>Link Building</li>
                  <li style={{ padding: '0 0 8px', }}>Keyword Tracking</li>
                  <li style={{ padding: '0 0 8px', color: "#3a506b" }}>Website Analytics</li>
                </ul>
              </div>
              <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background:
                    "linear-gradient(96deg,#6254e7 0%,#9289f1 100%)",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Hire Ecommerce Developers
              </Button>

            </Grid>
          </Grid>
        </Container>
      </section>


      <setion>
        <Container>
          <div className="ts-18">
            <div>
              <div>
                <p
                  className="text-bold text-uppercase"
                  style={{ color: "#5747e4" }}
                >
                  WE are
                </p>
              </div>
            </div>
            <div>
              <div>
                <p>
                  Social Media Marketing is all the rage in today. We don’t think I need to tell you how big social media is. Social media is the fastest-growing trend in the history of the world. This sector has grown faster than the Internet itself. Within the first ten years of being publicly available, the Internet managed to gather roughly 1 billion users. So, it doesn’t matter what type of business you’re or what kind of services you provide. You can always find new customers on social media.
                </p>
                <p>
                  If you are a small business and wondering if social media marketing can help you. Let me tell it, it absolutely can. People are always on their phones. Whether it be them watching a YouTube video or going through their Facebook account. In fact, people are so addicted to their mobile phones and the social media apps on them that there’s now a word for our obsession. With such widespread use, social media presents an incredible marketing opportunity. You should start using social media marketing already or you’ll lose in the long run.
                </p>
                <p>
                  One of the biggest advantages of social media is cost. Social media marketing is way cheaper than traditional marketing. Traditional marketing like TV ads and pamphlets can cost you more than Rs.20,000 and you don’t even have the guarantee that it will work. But with social media, you can guarantee your success. That’s because you can target your ads to a specific group of people or place. Social media can do this because they have all the user’s information with them. For example, Facebook knows a user’s behaviour like what they like to eat and where they like to go. Now, this might sound scary to you, but it is true and as a business, you can take advantage of that. For example if you are a restaurant in Guwahati, you can target your Facebook ads to the people of Guwahati. This helps reduce the cost of ads considerably. You can even change the target audience for each post. You don’t get this kind of flexibility with traditional media like TV.
                </p>
                <p>
                  We here at Zoodonix take great pride in being the premier
                  <a href="https://zoodonix.com">Social Media Marketing service provider in Guwahati and North-East India</a>. We provide great service with the lowest cost so that you get the best bang for your buck. We provide service to all kind of businesses whether small or big and give equal amount of importance to both. Customer satisfaction is our top priority. Our philosophy is that “We grow with our clients”.
                </p>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

        </Container>
      </setion>


      <section style={{ marginTop: '80px' }}>
        <Container>
          <div style={{ textAlign: "center" }}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Best for you
            </div>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              How Our Team Can Help
            </Typography>
            <p style={{ fontSize: "20px" }}>
              We are renowned custom web app development company in <br />{" "}
              Guwahati, offering wide range of web development services <br />{" "}
              that caters to all your business needs:
            </p>
          </div>
          <Grid container spacing={12}>
            {ourTeamGridData.map((item, index) => (
              <Grid item xs={12} md={4} key={item.id}>
                <img
                  src={item.imgSrc}
                  width={50}
                  height={50}
                  alt="Placeholder 1"
                  style={{ marginRight: "10px" }}
                />
                <div style={{ display: "flex", padding: "0px" }}>
                  <div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: `${item.color}`,
                      }}
                    >
                      {"0" + item.id}
                      <br />
                      {item.title}
                    </div>
                    <p
                      className="our-team-card-description"
                      style={{
                        fontSize: "18px",
                        color: "#8d99ae",
                        marginTop: "0",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      <section style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}>
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12} md={4}>
              {Array.from({ length: 3 }).map(() => (
                <div style={{ marginTop: '60px' }}>
                  <div style={{ display: 'flex' }}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontWeight: "bold",
                        color: "#3a506b",
                        marginTop: "-3px",
                        marginRight: "5px"
                      }}
                    >
                      In-depth Keyword Research
                    </Typography>
                    <CheckCircleIcon style={{ color: '#38b000' }} />
                  </div>
                  <p style={{ marginTop: "0px", marginBottom: "0" }}>
                    We will focus on keywords that are right for your business, product, or service. Keywords that we know your customers are searching for. Keywords that will have an impact to your business.
                  </p>
                </div>
              ))}
            </Grid>

            {/* App UI Image  */}
            <Grid item xs={12} md={4}>
              <div>
                <img src={AppUiDesign} />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              {Array.from({ length: 3 }).map(() => (

                <div style={{ marginTop: '60px' }}>
                  <div style={{ display: 'flex' }}>
                    <CheckCircleIcon style={{ color: '#5465ff' }} />
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold", color: "#3a506b", marginTop: '-3px', marginLeft: '5px' }}
                    >
                      In-depth Keyword Research
                    </Typography>
                  </div>
                  <p style={{ marginTop: "0px", marginBottom: "0" }}>
                    We will focus on keywords that are right for your business, product or service. Keywords that we know your customers are searching for. Keywords that will have an impact to your business.
                  </p>
                </div>
              ))}
            </Grid>
          </Grid>
        </Container>
      </section>



      <section style={{
        padding: "20px",
      }}>
        <Container>
          <div
            style={{
              textAlign: "center",
              backgroundImage:
                "linear-gradient(80deg, #de6262 8%, #ffb88c 82%)",
              padding: "20px",
              color: "#fff",
              borderRadius: "20px",
              boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
            }}
          >
            <p className="text-uppercase text-bold">Welcome</p>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#fff" }}
              className="let-discuss-header"
            >
              Let's Discuss Your Project
            </Typography>
            <p className="let-discuss-para" style={{ fontSize: "18px" }}>
              We accept Mobile Application Development projects including Mobile
              App UI/UX Design from all major towns and cities of Assam
              including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
              Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
              Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
              to multiple cities of Northeast including Itanagar, Arunachal
              Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
              Agartala, Tripura, Kohima, Nagaland
            </p>
            <Button
              style={{
                padding: "15px 25px 15px 25px",
                background: "#fff",
                color: "black",
                borderRadius: "40px",
              }}
              variant="contained"
              color="#7209b7"
              className="text-uppercase"
            >
              Talk our experts
            </Button>
          </div>
        </Container>
      </section>



      <section>
        <Container>
          <div>
            <div>
              <div>
                <div>
                  <div></div>
                </div>
              </div>
            </div>
            <div>
              <div className="ts-18">
                <p>
                  It’s almost impossible to rank a website on the 1st page of Google with traditional SEO techniques. SEO algorithms have completely changed from how they were earlier. Today, SEO is all about user experience. When a user is trying to reach your website, there are various metrics that can tell you whether your website is user-friendly or not. One of them is the time your website takes to load the content. How much time do users stay on your website? Is your website compatible with multiple devices like laptops, mobile, tablets, etc? Does your website have navigation? First-page ranking on Google is definitely possible if your website has a good user experience.
                  <br />
                  At Zoodonix, our approach has always been highly structured, data and audience-driven, and focused on numbers with time-tested techniques such as geo-targeting and age demographics to out-of-the-box solutions to the age-old question—Who IS your target audience?
                  <br />
                  A top SEO company in Guwahati, Assam should be capable of bringing better user experience to your website when you hire them for your SEO. The right SEO company will create trust among your users when they provide a better user experience, which will lead to generating more leads/conversions for your business. Zoodonix is a company that can do all these always changing and evolving SEO techniques and help our clients to rank on the first page of Google, Bing, or other search engines when users search for your business-related keywords and drive organic traffic.
                </p>
                <p>
                  We look at the needs of your business in order to determine the best strategies for your social media activities. We create the social profiles that are right for your business, and add content and interact with the community at the times that are most valuable for gaining new customers and enticing existing customers to return. We also provide blogs, widgets, and articles that can be used to promote your brand and image through social media networks. We look not only at your business but the competition, as well as the communities that already exist, to see what the ideal strategy would be for you. We help determine which social media networks are the most used by your customers and maintain your social network profiles, constantly updating strategies and ensuring that your online reputation and image remain at a high level, which leads to more sales and increases revenue. Thus establishing you as well as{" "}
                  <a href="#">
                  Zoodonix as a Leading Company in Assam, Northeast.
                  </a>
                </p>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

        </Container>
      </section>

      <section>
        <Container>
          <Typography variant='h2' sx={{textAlign:'center'}}>
              Testimonials 
          </Typography>
          <img src={FooterSvg} />
        </Container>
      </section>
      <Footer/>
    </>
  );
};

export default SeoServices;
